import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LoadingMode } from '../Components/LoadingMode';
import { IoIosArrowForward } from 'react-icons/io';

import newsImage from '../Assets/Image/newshero.jpg';
import cxImage from '../Assets/Image/crypto.jpg';

export default function FxNews() {
  const [isLoading, setIsLoading] = useState(false);
  const [news, setNews] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function getNews() {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/fx-news`
        );
        setNews(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
    getNews();
  }, []);

  return (
    <section className='px-4 sm:px-10 md:px-20 max-w-[1440px] mx-auto mt-8 md:mt-24 font-pin'>
      <div className='flex flex-col gap-[2rem]'>
        <h2 className='text-2xl font-semibold'>FX News</h2>
        <div className='flex flex-col md:flex-row items-stretch gap-11 justify-start'>
          <figure className='w-full md:w-[50rem] flex flex-col shadow-md rounded-md overflow-hidden  '>
            <div className='w-full h-full'>
              <img
                src={newsImage}
                alt='hero-img'
                className='w-full h-full object-cover object-center'
              />
            </div>
            <figcaption className=' bg-p-bk text-white '>
              <h2 className='capitalize font-semibold text-[1.2rem] md:text-[1.4rem] lg:text-[1.8rem] lg:leading-[40px] py-[5px] pl-[2rem] pr-[0.5rem]'>
                We are a FX Trading social Platform trusted by many client
              </h2>
            </figcaption>
          </figure>

          <figure className='w-full md:w-[32rem] flex flex-col gap-[2rem] shadow-md rounded-md overflow-hidden'>
            <div className='w-full h-full'>
              <img
                src={cxImage}
                alt='fx-img'
                className='w-full h-full object-contain object-top'
              />
            </div>

            <figcaption className='px-3 pb-2'>
              <h4 className='capitalize font-medium text-[1.4rem] md:text-[1.56rem] mb-[0.6rem] leading-[2rem] '>
                We are a FX Trading social Platform trusted by many client
              </h4>
              <button
                className='text-p-bk font-rbt text-base font-semibold leading-9 flex items-center gap-[8px] hover:text-black transition-all duration-300'
                onClick={() => navigate(`/fXnews/0`)}
              >
                Read more
                <IoIosArrowForward />
              </button>
            </figcaption>
          </figure>
        </div>
        {isLoading ? (
          <div>
            <LoadingMode />
          </div>
        ) : (
          news.map((newsData) => (
            <figure
              className='w-full md:w-[32rem] flex flex-col gap-[2rem] shadow-md rounded-md overflow-hidden'
              key={newsData.id}
            >
              <div className='w-full h-[22.7rem]'>
                <img
                  src={`https://apex.loyaltyview.com/storage/${newsData.images[0].image}`}
                  alt={`img-of-${newsData.title}`}
                  className='w-full h-full object-cover'
                />
              </div>

              <figcaption className='px-3 pb-1'>
                <h4 className='capitalize font-medium text-[1.56rem] mb-[0.6rem] leading-[2rem] '>
                  {newsData.title}
                </h4>
                <p className='text-[1rem] font-normal text-[#2C2F30] line-clamp-3 '>
                  {newsData.summary}
                </p>
                <button
                  className='text-p-bk font-rbt text-base font-semibold leading-9 flex items-center gap-[8px] hover:text-black transition-all duration-300'
                  onClick={() => navigate(`/fXnews/${newsData.id}`)}
                >
                  Read more
                  <IoIosArrowForward />
                </button>
              </figcaption>
            </figure>
          ))
        )}
      </div>
    </section>
  );
}
